import axios from "@/axios";

export function ProfileGet() {
  return axios.get("/profile");
}
